import { Component, OnInit, ViewChild, ElementRef } from '@angular/core'
import { DragAndDropEventArgs, NodeSelectEventArgs, TreeView } from '@syncfusion/ej2-angular-navigations';
import { enableRipple } from '@syncfusion/ej2-base';
enableRipple(true);
import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import {  kpi,  slakpiMapping, year, quater, slakpiInteraction } from './../../../models/slakpi';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { AdminApiService } from './../../../services/admin.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from './../../../services/user.service';
import { ToasterService } from './../../../toaster.service';

@Component({
  selector: 'app-kpi-mapping',
  templateUrl: './kpi-mapping.component.html',
  styleUrls: ['./kpi-mapping.component.css']
})
export class KpiMappingComponent implements OnInit {
  public sla_data: any;
  public kpi_data: any;
  public interaction_data: any;
  public interaction_data_archive: any;
  public interaction_data_temp: any;
  public kpi_interaction_data: any;
  public yearData: any;
  public quaterData: any;
  public permission: number = 1;

  // Mapping TreeView fields property with data source properties
  public fields_sla: Object;
  public fields_kpi: Object;
  public fields_mappings: Object;
  public fields_mappings_archive: Object;
  public fields_yearData: Object;
  public fields_quaterData: Object;
  public checkNodes: Object[] = [];
  public allowDragAndDrops: boolean = true;
  public year_default = 0;
  public year_archievedefault = this.year_default - 1;
  public year_selection: number = this.year_default - 1;
  public destYear: number;
  public quater_selection: number = 0;
  public quater_dragged: number = 1;
  public selected_kpiUno: number = 0;
  public selected_slaUno: number = 0;
  public selected_qUno: number = 0;
  public selected_yUno: number = 0;
  public isRemoveActive: boolean = false;
  public isMapActive: boolean = false;
  public objSLAKPIArr: slakpiMapping;
  public isKPIarchive: boolean = false;
  public dargged_yearstring: string = '0';
  public dargged_quater: string = '0';
  public dargged_sla: string = '0';
  public dargged_kpi: string = '0';
  public dropped_yearstring: string = '0';
  public dropped_quater: string = '0';
  public nodedroppedQuater: number = 0;
  public searchglobal: string = '';
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  isAdmin: boolean = false;
  selected_uno: string = '';
  public trend_data: any;

 // @ViewChild("inputObj_SLA", { static: false }) inputObj_SLA: ElementRef;
  @ViewChild("inputObj_KPI", { static: false }) inputObj_KPI: ElementRef;
  @ViewChild("inputObj_Tree", { static: false }) inputObj_Tree: ElementRef;
  @ViewChild("inputObj_Tree_archive", { static: false }) inputObj_Tree_archive: ElementRef;

  @ViewChild("tree2", { static: false }) tree2: TreeView;

  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  public frequency_data: any;
  public slaStatusRule_data: any;
  //for search
  public kpisearch_text: string = '';
  public _text: string = '';
  public kpisearch_trendUno: any = 0; 
  public kpisearch_trendName: number = 0; 
  public kpiCountDragged: number = 0;
  public kpisearch_frequencyuno: number = 0;

  public kpiCount_Q1: number = 0;
  public kpiCount_Q2: number = 0;
  public kpiCount_Q3: number = 0;
  public kpiCount_Q4: number = 0;

  public kpiCount_Q1_arch: number = 0;
  public kpiCount_Q2_arch: number = 0;
  public kpiCount_Q3_arch: number = 0;
  public kpiCount_Q4_arch: number = 0;

  noDataImg: any;
  tenantUno: any;
  isDigitalDewa: boolean = false;
  loading: boolean = false;
    intyearFilter: number;
    text: string;
    List_kpi: string;
    kpisearch: string;
  constructor(private toaster: ToasterService, public restApi: SLAKPIApiService, private _activatedRoute: ActivatedRoute, private router: Router, public adminService: AdminApiService, public utilityService: UtilityService, private spinner: SpinnerVisibilityService, private userService: UserService) {
    this.user = this.userService.getUserInfo();
    this.isDigitalDewa = (this.user.tenantDigitalUser == 'true') ? true : false;
  }

  ngOnInit() {
   
    this.userService.CheckLogin();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.currentYear = Number(this.user.currentYear);
    this.currentHalf = Number(this.user.currentHalf);
    this.currentQuarter = Number(this.user.currentQuarter);
    this.currentMonth = this.user.currentMonth;
    this.destYear = this.currentYear;
    //this.selected_qUno = this.user.currentQuarter;
    //this.selected_yUno = this.user.currentYear;
    this.year_default = this.currentYear;
    this.year_archievedefault = this.year_default - 1;
    this.year_selection = this.year_default - 1;

    
    //To Validate User Permission
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly') ? true : false;
    if (!this.isAdmin) {
      //this.CheckUserPermission();
    }
    else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;

    }

    //Load Default Values
    this._activatedRoute.params.subscribe((params: Params) => {

      if (params['pagetype'] != null && params['pagetype'] == 'ar') {

        this.isKPIarchive = true;
      } else {
        this.isKPIarchive = false;
      }
      this.Refresh_PageData(true);
    });

  }
  
  //Load Frequency Values
  loadFrequency() {
    
    if (this.isDigitalDewa == false) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' }
        //{ frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }

    if (this.isDigitalDewa == true || this.tenantUno == 5) {
      this.frequency_data = [];
      this.frequency_data = [
        { frequencyCode: 1, frequencyName: 'Yearly' },
        { frequencyCode: 2, frequencyName: 'Semi-annually' },
        { frequencyCode: 3, frequencyName: 'Quarterly' },
        { frequencyCode: 4, frequencyName: 'Monthly' }
      ];
    }
  }
  getTrend() {
    this.trend_data = [
      { trendUno: 1, trendName: 'Achievement' },
      { trendUno: 2, trendName: 'Reduction' }
     
    ];
  }

 
  Refresh_PageData(isPageLoad) {

    if (isPageLoad) {
      this.loadYear();
      this.loadQuater();

      //for Custom Mapping
      if (!this.isKPIarchive) {
       // this.loadSLA();
        this.loadKPI();
       this.loadSLAKPIYear((this.currentYear), 0, 'mapping');
        this.loadFrequency();
        this.getTrend();
      }
      else {
        //for Archive Mapping
        //if (this.selected_yUno > 0) {
        //this.loadSLAKPIYear((this.selected_yUno), 0, 'archive');
        //} else {
        
        //this.quater_selection = this.currentQuarter;
        //this.year_selection = this.currentYear - 1;
        this.loadSLAKPIYear((this.year_selection), this.quater_selection, 'archive');
        // }
        this.loadSLAKPIYear((this.currentYear), 0, 'mapping');
      }

    }
    this.objSLAKPIArr = new slakpiMapping();


    this.isRemoveActive = false;
    this.isMapActive = false;
   // this.selected_slaUno = 0;
    this.selected_kpiUno = 0;
    this.selected_qUno = 0;
    this.selected_yUno = 0;
    this.dargged_yearstring = '0';
    this.dargged_quater = '0';
   // this.dargged_sla = '0';
    this.dargged_kpi = '0';
  }

  // Get Year / Quater
  loadYear() {

    let inpValue = new year();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getYearMasterAll(inpValue)
      .subscribe(data => {
             this.yearData = data;
        //this.yearData = this.yearData.filter(year => year.displayText != this.year_default);
        //this.yearData = this.yearData.sort((one, two) => (one > two ? 1 : -1));
        this.fields_yearData = { text: 'displayText', value: 'value' };;
        setTimeout(() => {
          
          // this.localyear.value = (Number(this.currentYear) - 1);
          // this.localyeararch.value = (Number(this.currentYear) - 1);

        }, 500);


      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }
  loadQuater() {

    let inpValue = new quater();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getQuaterMaster(inpValue)
      .subscribe(data => {

        this.quaterData = data;
        this.fields_quaterData = { text: 'displayText', value: 'value' };
        setTimeout(() => {

          // this.localquatersmap.value = Number(this.currentQuarter);
          // this.localquater.value = Number(this.currentQuarter);
          // this.localquaterarch.value = Number(this.currentQuarter);

        }, 10);

      },
        (error) => {
          //Called when error

        }
      ).add(() => {
        //Called when operation is complete (both success and error)

      });
  }

  loadKPI() {
    
    this.kpisearch = "";
    this.kpisearch_trendUno = "";
    this.spinner.show();
    let inpValue = new kpi();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKPI(inpValue)
      .subscribe(data => {

        this.kpi_data = data;
        this.fields_kpi = { dataSource: this.kpi_data, id: 'strKPIUno', text: 'kpiNameCode', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
        this.spinner.hide();
      },

        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  //Get SLA&KPI Mapping
  loadSLAKPIYear(intyearFilter: number, quaterFilter: number, type: string) {
    
    this.spinner.show();
    let inpValue = new slakpiInteraction();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.yearFilter = intyearFilter;
    inpValue.yearFilterDefault = intyearFilter;
    inpValue.quaterFilter = quaterFilter;
    inpValue.nodedroppedQuater = this.quater_dragged;;

    this.restApi.getKPIMappings(inpValue)
      .subscribe(data => {
        if (type == 'archive') {
          
          this.interaction_data_archive = data;
          this.fields_mappings_archive = { dataSource: this.interaction_data_archive, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
          let tt: any = this.fields_mappings_archive;
          
          this.kpiCount_Q1_arch = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_1") && d.type === 'kpi').length;
          this.kpiCount_Q2_arch = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_2") && d.type === 'kpi').length;
          this.kpiCount_Q3_arch = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_3") && d.type === 'kpi').length;
          this.kpiCount_Q4_arch = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_4") && d.type === 'kpi').length;
        } else {

          this.interaction_data = data;
          this.fields_mappings = { dataSource: this.interaction_data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
       
          let tt: any = this.fields_mappings;
          
          this.kpiCount_Q1 = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_1") && d.type === 'kpi').length;
          this.kpiCount_Q2 = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_2") && d.type === 'kpi').length;
          this.kpiCount_Q3 = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_3") && d.type === 'kpi').length;
          this.kpiCount_Q4 = tt.dataSource.filter(d => d.uno.startsWith("Y_" + intyearFilter.toString() + "@Q_4") && d.type === 'kpi').length;
        }

        setTimeout(() => {
          this.loading = false;
        }, 200);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.loading = false;
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }


  public nodeDropped_slamap(args: DragAndDropEventArgs): void {

  }
  public nodeDrag_slaarch(args: DragAndDropEventArgs): void {
    args.cancel = true;
  }
  public nodeDropped_slaarch(args: DragAndDropEventArgs): void {
    args.cancel = true;
  }

  public onNodeSelecting_slamap(args: NodeSelectEventArgs): void {
    
    let id: any = args.nodeData.id;
    let pid: any = args.nodeData.parentID;
    
    if (id.indexOf('S_') >= 0 || id.indexOf('s_') >= 0) {
      this.selected_slaUno = id.replace('s_', '').replace('S_', '');
      this.selected_qUno = pid.replace('q_', '').replace('Q_', '');
      this.selected_yUno = 0;//pid.replace('q_', '').replace('Q_', '');
      this.isRemoveActive = true;
    }
    if (id.indexOf('K_') >= 0 || id.indexOf('k_') >= 0) {
      this.selected_kpiUno = id.replace('k_', '').replace('K_', '');
      this.selected_slaUno = pid.replace('s_', '').replace('S_', '');
      this.selected_qUno = 0;
      this.selected_yUno = 0;
      this.isRemoveActive = true;
    }

    /* dataSLAKPI = (draggedNodeData_Type == 'sla') ? dataSLAKPI.replace('s_', '').replace('S_', '') : dataSLAKPI.replace('k_', '').replace('K_', '');*/
    this.selected_yUno = 0;
    this.selected_qUno = 0;
    this.selected_slaUno = 0;
    this.selected_kpiUno = 0;
    this.selected_uno = '';
    
    let droppedNodeData_Data = args.nodeData.id.toString().split('@');
    this.selected_uno = args.nodeData.id.toString();
    if (droppedNodeData_Data.length > 0) { this.selected_yUno = parseInt(droppedNodeData_Data[0].toString().replace('y_', '').replace('Y_', '')) } else { this.selected_yUno = parseInt(args.nodeData.id.toString().replace('y_', '').replace('Y_', '')); }
    if (droppedNodeData_Data.length >= 2) { this.selected_qUno = parseInt(droppedNodeData_Data[1].toString().replace('q_', '').replace('Q_', '')) }
    if (droppedNodeData_Data.length >= 3) { this.selected_kpiUno = parseInt(droppedNodeData_Data[2].toString().replace('k_', '').replace('K_', '')) }
    if (droppedNodeData_Data.length >= 4) { this.selected_kpiUno = parseInt(droppedNodeData_Data[3].toString().replace('k_', '').replace('K_', '')) }

    this.isRemoveActive = true;
  }

  public nodeDrag(args: DragAndDropEventArgs, origin: any): void {
    if (!this.permision_edit && !this.permision_add) args.dropIndicator = 'e-no-drop';

    let drId: any = (args != null && args.droppedNodeData != null) ? args.droppedNodeData.id : '';
    if (args != null && args.droppedNodeData != null && drId.indexOf('K_') <= 0 && args.dropLevel > 1 && origin == 1) {

      //get the dragged node info
      let draggedNodeData_Data = args.draggedNodeData.id.toString().toLocaleLowerCase().split('_');

      let draggedNodeData_ID = draggedNodeData_Data[1];
      // draggedNodeData_Type = draggedNodeData_Data[0] == 's' ? 'sla' : '';
      let draggedNodeData_Type = draggedNodeData_Data[0] == 'k' ? 'kpi' : '';
      draggedNodeData_Type = draggedNodeData_Data[0] == 'y' ? 'year' : draggedNodeData_Type;
      draggedNodeData_Type = draggedNodeData_Data[0] == 'q' ? 'quater' : draggedNodeData_Type;
      //get the droped node info 
      let droppedNodeData_Data = args.droppedNodeData.id.toString().split('@');
      let droppedNodeData_ID = args.droppedNodeData.id.toString();
      let droppedNodeData_Type = 'year';
      if (droppedNodeData_Data.length == 0) { droppedNodeData_Type = 'year'; }
      if (droppedNodeData_Data.length == 2) { droppedNodeData_Type = 'quater'; }
      if (droppedNodeData_Data.length == 3) { droppedNodeData_Type = 'kpi'; }
     /* if (droppedNodeData_Data.length == 4) { droppedNodeData_Type = 'kpi'; }*/

      if (droppedNodeData_Type == 'kpi') {
        args.dropIndicator = 'e-no-drop';
      }
      if (droppedNodeData_Type == 'year' && draggedNodeData_Type != 'quater') {
        args.dropIndicator = 'e-no-drop';
      }
      if (droppedNodeData_Type == 'quater' && draggedNodeData_Type != 'kpi') {
        args.dropIndicator = 'e-no-drop';
      }
      if (droppedNodeData_Type == 'kpi' && draggedNodeData_Type != 'kpi') {
        args.dropIndicator = 'e-no-drop';
      }

    }
    else if (args != null) {
      args.dropIndicator = 'e-no-drop';
    }
  }

  public dragStop(args: DragAndDropEventArgs, origin: any): void {
    
    if (!this.permision_edit && !this.permision_add) { args.cancel = true; return; }

    
    let drId: any = args.droppedNodeData != null ? args.droppedNodeData.id : '';
    if (args != null && args.droppedNodeData != null && drId.indexOf('K_') <= 0 && args.dropIndicator == "e-drop-in" && origin == 1) {

      //get the dragged node info
      let draggedNodeData_Data;
      let draggedNodeData_ID;
      let draggedNodeData_Type;
      if (args.draggedNodeData.id.toString().indexOf('@') >= 0) {

        draggedNodeData_Data = args.draggedNodeData.id.toString().toLocaleLowerCase().split('@');
        if (draggedNodeData_Data.length == 2) {
          draggedNodeData_Type = 'quater';
          draggedNodeData_ID = draggedNodeData_Data[1].split('_')[1];

          this.dargged_yearstring = draggedNodeData_Data[0].split('_')[1];
          this.dargged_quater = draggedNodeData_Data[1].split('_')[1];
        }
        if (draggedNodeData_Data.length == 3) {
          draggedNodeData_Type = 'kpi';
          draggedNodeData_ID = draggedNodeData_Data[2].split('_')[1];
          this.dargged_yearstring = draggedNodeData_Data[0].split('_')[1];
          this.dargged_quater = draggedNodeData_Data[1].split('_')[1];
          this.dargged_sla = draggedNodeData_Data[2].split('_')[1];
        }
      
      }
      else {
        draggedNodeData_Data = args.draggedNodeData.id.toString().toLocaleLowerCase().split('_');
        draggedNodeData_ID = draggedNodeData_Data[1];
        draggedNodeData_Type = draggedNodeData_Data[0] == 'k' ? 'kpi' : '';
        draggedNodeData_Type = draggedNodeData_Data[0] == 'y' ? 'year' : draggedNodeData_Type;
        draggedNodeData_Type = draggedNodeData_Data[0] == 'q' ? 'quater' : draggedNodeData_Type;

      }
      //get the droped node info 
      let droppedNodeData_Data = args.droppedNodeData.id.toString().split('@');
      let droppedNodeData_ID = args.droppedNodeData.id.toString();
      let droppedNodeData_Type = 'year';
      if (droppedNodeData_Data.length == 0) { droppedNodeData_Type = 'year'; }
      if (droppedNodeData_Data.length == 2) { droppedNodeData_Type = 'quater'; }
      if (droppedNodeData_Data.length == 3) { droppedNodeData_Type = 'kpi'; }
     
      else if (droppedNodeData_Type == 'year' && draggedNodeData_Type != 'quater') {
        args.cancel = true;
        return;
      }
      else if (droppedNodeData_Type == 'quater' && draggedNodeData_Type != 'kpi') {
        args.cancel = true;
        return;
      }
     
      else {
        if ((droppedNodeData_Type == 'year' && draggedNodeData_Type == 'quater') || (droppedNodeData_Type == 'quater' && draggedNodeData_Type == 'kpi'))
        {
          if (droppedNodeData_Type == 'year' && draggedNodeData_Type == 'quater') {


            this.AddEditSLAKPI_Array(draggedNodeData_ID, args.droppedNodeData.id.toString(), draggedNodeData_Type, args.draggedNodeData.text.toString());
            return;
          }
          else if (!this.check_duplicateSLAKPI(args.draggedNodeData.id.toString().trim(), args.droppedNodeData.id.toString().trim())) {
            
            if (draggedNodeData_Type == 'kpi') {
              //validating semi / Yearly type kpi
              let tmpKPICount = this.kpi_data.filter(order => order.kpiUno == draggedNodeData_ID);
              if (tmpKPICount != null && tmpKPICount.length > 0) {
                if (tmpKPICount[0].scheduleUno == 1 && droppedNodeData_Data[1] != 'Q_4') {
                  //Swal.fire('Error', 'Yearly KPI only allowed in Q4');
                  this.toaster.show('error', 'Error', 'Yearly KPI only allowed in Q4.');
                  args.cancel = true;
                } else if (tmpKPICount[0].scheduleUno == 2 && !(droppedNodeData_Data[1] == 'Q_2' || droppedNodeData_Data[1] == 'Q_4')) {
                  // Swal.fire('Error', 'Semi-annually KPI only allowed in Q2 / Q4');
                  this.toaster.show('error', 'Error', 'Semi-annually KPI only allowed in Q2 / Q4');
                  args.cancel = true;
                } else {
                   this.AddEditSLAKPI_Array(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString(), draggedNodeData_Type, args.draggedNodeData.text.toString());
                 
                }

              }
            }
            else {
               this.AddEditSLAKPI_Array(args.draggedNodeData.id.toString(), args.droppedNodeData.id.toString(), draggedNodeData_Type, args.draggedNodeData.text.toString());
              
            }

            //(document.getElementById("data-uid") as HTMLElement).attributes;
            return;
          }
          else {
            args.cancel = true;
            //Swal.fire('Error', 'Duplicate ' + (draggedNodeData_Type == 'sla' ? 'SLA' : 'KPI') + ' are not allowed', 'warning');
            this.toaster.show('warning', 'Warning', 'Duplicate ' + (draggedNodeData_Type == 'sla' ? 'SLA' : 'KPI') + ' are not allowed');
            return;
          }
        }

      }


    }
    else if (args != null) {
      args.cancel = true;
      return;
    }


  }

  public onNodeSelecting_slamapArchive(args: NodeSelectEventArgs): void {
    
    this.selected_yUno = 0;
    this.selected_qUno = 0;
    this.selected_kpiUno = 0;
    this.selected_uno = '';

    let droppedNodeData_Data = args.nodeData.id.toString().split('@');
    this.selected_uno = args.nodeData.id.toString();
    if (droppedNodeData_Data.length > 0) { this.selected_yUno = parseInt(droppedNodeData_Data[0].toString().replace('y_', '').replace('Y_', '')) } else { this.selected_yUno = parseInt(args.nodeData.id.toString().replace('y_', '').replace('Y_', '')); }
    if (droppedNodeData_Data.length >= 2) { this.selected_qUno = parseInt(droppedNodeData_Data[1].toString().replace('q_', '').replace('Q_', '')) }
    if (droppedNodeData_Data.length >= 3) { this.selected_kpiUno = parseInt(droppedNodeData_Data[3].toString().replace('k_', '').replace('K_', '')) }
    this.isRemoveActive = true;

  }
  public nodeDragArchive(args: DragAndDropEventArgs, origin: any): void {
    if (!this.permision_edit && !this.permision_add) args.dropIndicator = 'e-no-drop';
    let drId: any = (args != null && args.droppedNodeData != null) ? args.droppedNodeData.id : '';
    if (args != null && args.droppedNodeData != null && drId.indexOf('K_') <= 0 && args.dropLevel > 1 && origin == 1) {

      //get the dragged node info
      let draggedNodeData_Data;
      let draggedNodeData_ID;
      let draggedNodeData_Type;
      if (args.draggedNodeData.id.toString().indexOf('@') >= 0) {
        this.kpiCountDragged = 0;

        draggedNodeData_Data = args.draggedNodeData.id.toString().toLocaleLowerCase().split('@');
        let temp:any = this.fields_mappings_archive;
        this.kpiCountDragged = temp.dataSource.filter(d => d.uno.startsWith(args.draggedNodeData.id.toString()) && d.type === 'kpi').length;
        if (draggedNodeData_Data.length == 2) {
          draggedNodeData_Type = 'quater';
          draggedNodeData_ID = draggedNodeData_Data[1].split('_')[1];

          this.dargged_yearstring = draggedNodeData_Data[0].split('_')[1];
          this.dargged_quater = draggedNodeData_Data[1].split('_')[1];
        }
    
        if (draggedNodeData_Data.length == 3) {
          draggedNodeData_Type = 'kpi';
          draggedNodeData_ID = draggedNodeData_Data[2].split('_')[1];
          this.dargged_yearstring = draggedNodeData_Data[0].split('_')[1];
          this.dargged_quater = draggedNodeData_Data[1].split('_')[1];
          this.dargged_kpi = draggedNodeData_Data[2].split('_')[1];
        }

      }
    }
    else if (args != null) {
      args.dropIndicator = 'e-no-drop';
    }
  }
  public dragStopArchive(args: DragAndDropEventArgs, origin: any): void {
    
    if (!this.permision_edit && !this.permision_add) { args.cancel = true; return; }
    let drId: any = args.droppedNodeData.id;
    if (args != null && args.droppedNodeData != null && drId.indexOf('K_') <= 0 && args.dropIndicator == "e-drop-in" && origin == 1) {

      //get the droped node info 
      let droppedNodeData_Data = args.droppedNodeData.id.toString().split('@');
      let droppedNodeData_ID = args.droppedNodeData.id.toString();
      let droppedNodeData_Type = 'year';
      if (droppedNodeData_Data.length == 1) {
        droppedNodeData_Type = 'year';

        this.dropped_yearstring = droppedNodeData_Data[0].split('_')[1];
      }

      if (droppedNodeData_Data.length == 2) {
        droppedNodeData_Type = 'quater';
        droppedNodeData_ID = droppedNodeData_Data[1].split('_')[1];

        this.dropped_yearstring = droppedNodeData_Data[0].split('_')[1];
        this.dropped_quater = droppedNodeData_Data[1].split('_')[1];
      }

     // this.AddEditSLAKPIArchive();
    }
    else if (args != null) {
      args.cancel = true;
      return;
    }
  }
  public nodeDropped_slamapArchive(args: DragAndDropEventArgs): void {

  }


  check_duplicateSLAKPI(dataKPI: string, droppedNodeData_Data: string) {
    
    var rtnchkval = false;
    var year = droppedNodeData_Data[0];
    var quater = droppedNodeData_Data[1];
    var filteredArray = this.interaction_data.forEach(function (intData) {

      if ((intData.uno != null &&  intData.uno.toLocaleLowerCase().trim() == (droppedNodeData_Data + '@' + dataKPI).toLocaleLowerCase())) {
        rtnchkval = true;
      }
    });

    return rtnchkval;
  }

  AddEditSLAKPI_Array(dataSLAKPI: string, dataMapping: string, draggedNodeData_Type: string, draggedNodeName: string) {
    
    dataSLAKPI = (draggedNodeData_Type == 'kpi') ? dataSLAKPI.replace('k_', '').replace('K_', '') : dataSLAKPI.replace('k_', '').replace('K_', '');

    let droppedNodeData_Data = dataMapping.split('@');
    let data_year = droppedNodeData_Data[0].toString().replace('y_', '').replace('Y_', '');
    let data_quater = (draggedNodeData_Type == 'quater') ? dataSLAKPI : droppedNodeData_Data[1].toString().replace('q_', '').replace('Q_', '');

    let data_kpi = (draggedNodeData_Type == 'kpi') ? dataSLAKPI :
      (draggedNodeData_Type == 'quater') ? '0' : droppedNodeData_Data[2].toString().replace('k_', '').replace('K_', '');
    //let data_kpi = (draggedNodeData_Type == 'kpi') ? '0' :
    //  (draggedNodeData_Type == 'quater') ? '0' : dataSLAKPI;


    this.PushobjInteraction_Data(data_year, data_quater, data_kpi, dataMapping, draggedNodeData_Type, draggedNodeName, droppedNodeData_Data[1].toString(), droppedNodeData_Data[0].toString(), dataSLAKPI);

    this.isMapActive = true;

    setTimeout(() => { this.inputObj_Tree.nativeElement.value = ""; }, 500);
    // this.AddEditSLAKPI();
  }

  PushobjSLAKPI(data_year, data_quater, data_kpi, uno) {
    let objSLAKPI = new slakpiMapping();
    objSLAKPI.slakpiyearUno = 0;
    objSLAKPI.kpiyear = parseInt(data_year);
    objSLAKPI.kpiquarter = parseInt(data_quater);
    objSLAKPI.kpiUno = parseInt(data_kpi);
    objSLAKPI.kpiUno = parseInt(data_kpi);
    objSLAKPI.tenantUno = this.tenantUno;
    objSLAKPI.userUno = this.login_UserID;
    objSLAKPI.uno = uno;
    objSLAKPI.draggedslayear = parseInt(this.dargged_yearstring);
    objSLAKPI.draggedslaquarter = parseInt(this.dargged_quater);
   // objSLAKPI.draggedslaUno = parseInt(this.dargged_sla);
    objSLAKPI.draggedkpiUno = parseInt(this.dargged_kpi);
    this.quater_dragged = parseInt(data_quater);
    this.objSLAKPIArr.objslakpiInteraction.push(objSLAKPI);


  }

  PushobjInteraction_Data(data_year, data_quater,  data_kpi, dataMapping, draggedNodeData_Type, draggedNodeName, quater, year, id) {
    //let objSLAKPI = new slakpiInteraction();
    //objSLAKPI.condition = 0;
    //objSLAKPI.expanded = true;
    //objSLAKPI.hasChild = (draggedNodeData_Type == 'sla' || draggedNodeData_Type == 'quater') ? true : false;
    //objSLAKPI.icon = (draggedNodeData_Type == 'sla') ? 'sla' : (draggedNodeData_Type == 'kpi') ? 'kpi' :'quater';
    //objSLAKPI.itemUno = 0;
    //objSLAKPI.name = draggedNodeName;
    //objSLAKPI.uno = dataMapping + ((draggedNodeData_Type == 'sla') ? '@S_' + data_sla : (draggedNodeData_Type == 'kpi') ? 'K_' + data_kpi : '');
    //objSLAKPI.puno = (draggedNodeData_Type == 'sla') ? quater : 'S_' + data_sla;
    //objSLAKPI.type = (draggedNodeData_Type == 'sla') ? 'sla' : 'kpi';
    //objSLAKPI.userUno = 2;
    //objSLAKPI.tenantUno = 1;
    //objSLAKPI.languageUno = 2;

    let hasChild = (draggedNodeData_Type == 'kpi' || draggedNodeData_Type == 'quater') ? true : false;

    let icon = (draggedNodeData_Type == 'kpi') ? 'kpi' : (draggedNodeData_Type == 'kpi') ? 'kpi' : 'quater';
    let itemUno = 0;
    let name = draggedNodeName;
    let uno = dataMapping + ((draggedNodeData_Type == 'kpi') ? '@K_' + data_kpi : (draggedNodeData_Type == 'kpi') ? '@K_' + data_kpi : '');

    let puno = dataMapping;//(draggedNodeData_Type == 'sla') ? dataMapping : dataMapping + 'S_' + data_sla;
    let type = (draggedNodeData_Type == 'kpi') ? 'kpi' : 'kpi';
    let u_id = (draggedNodeData_Type == 'kpi') ? ('k_' + id) : ('k_' + id);
    let userUno = 2;
    let tenantUno = this.tenantUno;
    let languageUno = this.login_UserID;

    this.PushobjSLAKPI(data_year, data_quater,  data_kpi, uno);
    

    this.interaction_data.push({ uno: uno, pUno: puno, name: name, icon: icon, type: type, expanded: hasChild, hasChild: hasChild, userUno: userUno, tenantUno: tenantUno, languageUno: languageUno, itemUno: itemUno, condition: 0, quaterFilter: 0, yearFilter: 0, yearFilterDefault: 0, dragItem: true });

    var x = document.getElementsByTagName("li");
    for (var i = 0; i < x.length; i++) {
      if (x[i].getAttribute("data-uid") == u_id) {
        x[i].setAttribute("data-uid", uno);
      }
    }

    this.changeDataSource_Tree(this.interaction_data);
    /* this.fields_mappings = { dataSource: this.interaction_data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };*/
  }

  AddEditSLAKPI() {
    
    this.isMapActive = false;

      let objSLAKPIIndexCount = this.objSLAKPIArr.objslakpiInteraction.filter(d => d.kpiUno > 0).length;

      Swal.fire({
        title: '',
        html: 'Please confirm to update<br/> <b> Total KPI Added / Modified to the selected Year is: ' + objSLAKPIIndexCount,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {


          this.spinner.show();
         // this.draggedNodeName= draggedkpiUno
          this.restApi.addKPIMappings(this.objSLAKPIArr)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
                //Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong');
              }
              else {
                this.toaster.show('success', 'Success', 'Saved Successfully.');
                //Swal.fire({
                //  type: 'success',
                //  html: 'Saved Successfully',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                this.loadSLAKPIYear(this.destYear, this.quater_selection, 'mapping');
              
                this.loadKPI();
                
               
                this.Refresh_PageData(false);
              
               
              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });



          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.Refresh_PageData(true);
          return;
        }
      })

    
    return true;

  }

  DeleteSLAKPI_Interaction() {

    
    let isNewItem = false;
    if (this.objSLAKPIArr.objslakpiInteraction.length > 0) {
      let index = this.interaction_data.findIndex(d => d.uno === this.selected_uno); //find index in your array
      if (index >= 0) {
        this.interaction_data.splice(index, 1);//remove element from array
        isNewItem = true;
      }
      let objSLAKPIIndex = this.objSLAKPIArr.objslakpiInteraction.findIndex(d => d.uno === this.selected_uno);
      if (objSLAKPIIndex >= 0) {
        this.objSLAKPIArr.objslakpiInteraction.splice(objSLAKPIIndex, 1);//remove element from array
        isNewItem = true;
      }
      this.changeDataSource_Tree(this.interaction_data);


    }
    if (!isNewItem) {

      // if (this.selected_slaUno > 0 || (this.selected_kpiUno > 0)) {
      this.isRemoveActive = false;
      Swal.fire({
        title: 'Delete',
        text: 'Please confirm to delete',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.value) {
          
          let objKPI = new slakpiMapping();
         /* objKPI.slaUno = 1;*/
          objKPI.kpiUno = this.selected_kpiUno;
          objKPI.kpiquarter = this.selected_qUno;
          objKPI.kpiyear = this.selected_yUno;
          objKPI.userUno = this.login_UserID;
          objKPI.tenantUno = this.tenantUno;
          this.restApi.deleteKpiMappings(objKPI)
            .subscribe(data => {

              if (data != null && data != undefined && data != '') {
                // Swal.fire('Error', 'Something went wrong', 'error')
                this.toaster.show('error', 'Error', 'Something went wrong.');
              }
              else {
                this.toaster.show('success', 'Success', 'Deleted Succesfully.');
                //Swal.fire({
                //  type: 'success',
                //  title: 'Deleted',
                //  showConfirmButton: false,
                //  timer: 1500
                //})
                //this.loadKPI();
                // this.Refresh_PageData(true);


                this.loadSLAKPIYear((this.destYear), 0, 'mapping');
               

              }


              this.spinner.hide();
            },
              (error) => {
                //Called when error
                this.spinner.hide();
              }
            ).add(() => {
              //Called when operation is complete (both success and error)
              this.spinner.hide();
            });


          return;
        } else if (result.dismiss === Swal.DismissReason.cancel) {

          return;
        }
      });


      // }
    }
  }

  //Search

  changeDataSource_KPI(data) {
    
    this.fields_kpi = { dataSource: data, id: 'strKPIUno', text: 'kpiNameCode', child: 'child', iconCss: 'icon', selected: 'isSelected', type: 'type' };
  }



  searchNodes_KPI() {
    
    
    this.kpisearch_text = this.inputObj_KPI.nativeElement.value;
    
    this.SearchKPINodeValues();
  }
 
  onchangeFrequency(e) {
    
    this.kpisearch_frequencyuno = (e && e.length > 0 && e[0].frequencyCode) ? e[0].frequencyCode : 0;
    this.SearchKPINodeValues();
  }
  onchangeSlaRule(e) {
    
    this.kpisearch_trendUno = (e && e.length > 0 && e[0].value) ? e[0].value :0;
    this.SearchKPINodeValues();
  }
  SearchKPINodeValues() {
    

    if (this.kpisearch_text.trim() == "" && this.kpisearch_trendUno == 0) {
      this.changeDataSource_KPI(this.kpi_data);
    }
    else if (this.kpisearch_text.trim() != "" || this.kpisearch_trendUno > 0) {

      let predicate = (this.kpisearch_text.trim() != "") ? new Predicate('kpiNameCode', 'contains', this.kpisearch_text.trim(), true) : new Predicate('kpiNameCode', 'notequal', "", true);
      predicate = (this.kpisearch_trendUno > 0) ? predicate.and('trendUno', 'contains', this.kpisearch_trendUno, true) : predicate.and('trendUno', 'greaterthan', 0, true);

     

      let filteredList = new DataManager(this.kpi_data).executeLocal(new Query().where(predicate));
      if (filteredList.length == 0) {
        this.changeDataSource_KPI([]);
      } else {
        this.changeDataSource_KPI(filteredList);
      }
    }
  }

  changeDataSource_Tree(data) {

    //let treeelm: any = document.querySelector('#tree2');
    //let treeInstance: TreeView = getComponent(treeelm, 'treeview');

    //treeInstance.fields = { dataSource: data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };


    this.fields_mappings = { dataSource: data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
    //this.tree2.dataBind();

    //this.tree2.refresh();
  }
  //Filtering the TreeNodes

  searchNodes_Tree() {
    
    let _text = this.inputObj_Tree.nativeElement.value;
    this.searchglobal = _text;
    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_Tree(this.interaction_data);
    }
    else if (_text.trim().length > 1) {
      let predicate = new Predicate('name', 'contains', _text.trim(), true);
      let filteredList = new DataManager(this.interaction_data).executeLocal(new Query().where(predicate));

      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["uno"]);
        var filters = this.getFilterItems(filteredList[j], this.interaction_data);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('uno', 'equal', filters[i], false));
          }
        }
      }

   
      if (filteredList.length == 0) {
        this.changeDataSource_Tree([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.interaction_data).executeLocal(query);
        this.changeDataSource_Tree(newList);

      }

    }
  }

  changeDataSource_Tree_Archive(data) {
    this.fields_mappings_archive = { dataSource: data, id: 'uno', parentID: 'pUno', text: 'name', hasChildren: 'hasChild', iconCss: 'icon' };
  }
  //Filtering the TreeNodes
  searchNodes_Tree_Archive() {
   

    let _text = this.inputObj_Tree_archive.nativeElement.value;

    let predicats = [], _array = [], _filter = [];
    if (_text.trim() == "") {
      this.changeDataSource_Tree_Archive(this.interaction_data_archive);
    }
    else if (_text.trim().length > 1) {
      let predicate = new Predicate('name', 'contains', _text.trim(), true);
      let filteredList = new DataManager(this.interaction_data_archive).executeLocal(new Query().where(predicate));

      for (var j = 0; j < filteredList.length; j++) {
        _filter.push(filteredList[j]["uno"]);
        var filters = this.getFilterItems(filteredList[j], this.interaction_data_archive);
        for (var i = 0; i < filters.length; i++) {
          if (_array.indexOf(filters[i]) == -1 && filters[i] != null) {
            _array.push(filters[i]);
            predicats.push(new Predicate('uno', 'equal', filters[i], false));
          }
        }
      }
      if (filteredList.length == 0) {
        this.changeDataSource_Tree_Archive([]);
      } else {
        let query = new Query().where(Predicate.or(predicats));
        let newList = new DataManager(this.interaction_data_archive).executeLocal(query);
        this.changeDataSource_Tree_Archive(newList);

      }

    }
  }

  //Find the Parent Nodes for corresponding childs
  getFilterItems(fList, list) {
    
    let nodes = [];
    nodes.push(fList["uno"]);
    let query2 = new Query().where('uno', 'equal', fList["pUno"], false);
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length != 0) {
      let pNode = this.getFilterItems(fList1[0], list);
      for (var i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) == -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }

  onChangeQuaterMap(e): void {

    if (e != undefined) {
      this.quater_selection = (e && e.length > 0 && e[0].value) ? e[0].value : 0;
      //this.loadSLAKPIYear(this.year_selection, parseInt(this.quater_selection), 'mapping');
      this.loadSLAKPIYear((this.currentYear), this.quater_selection, 'mapping');

    }
  }

  onChangeQuater(e): void {
    
    if (e != undefined) {
      this.quater_selection = (e && e.length > 0 && e[0].value) ? e[0].value : 0;
      this.loadSLAKPIYear(this.year_selection, this.quater_selection, 'archive');
    }
    else {
      this.loadSLAKPIYear(this.year_selection, 0, 'archive');
    }
  }

  onChangeYear(e): void {
    
    if (e) {
      this.year_selection = (e && e.length > 0 && e[0].value) ? e[0].value : this.year_selection;
      this.loadSLAKPIYear(this.year_selection, this.quater_selection, 'archive');
    }
  }
  onChangeYear_slamap(e): void {
    
    this.text = "";
    if (e != undefined) {
      this.destYear = (e && e.length > 0 && e[0].value) ? e[0].value : 0;
      this.loadSLAKPIYear(this.destYear, 0, 'mapping');
    }
  }

 
  showSuccessToaster() {
    this.toaster.show('success', 'Well done!', 'This is a success alert');
  }
  showErrorToaster() {
    this.toaster.show('error', 'Check it out!', 'This is a error alert');
  }
  showWarningToaster() {
    this.toaster.show('warning', 'Check it out!', 'This is a warning alert', 3000);
  }
}
